function asciiToArray(string) {
  return string.split("");
}
module.exports = asciiToArray;
